import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "preview-cards-wrapper" }
const _hoisted_3 = { class: "preview-cards" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "scroll-ring"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_project_preview = _resolveComponent("project-preview")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          name: 'carousel-' + _ctx.direction
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              class: "card-item",
              key: _ctx.list[_ctx.index].pathToProject
            }, [
              _createVNode(_component_project_preview, {
                model: _ctx.list[_ctx.index],
                "can-redirect": true,
                class: "front-card",
                "is-preview": true
              }, null, 8, ["model"])
            ]))
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["project-navigator ln-glass-elevated", { 'navigator-hidden': _ctx.isMobile && !_ctx.isIntersecting }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, dotIndex) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: dotIndex,
          class: _normalizeClass(["nav-item", { 'active': dotIndex === _ctx.index }]),
          onClick: ($event: any) => (_ctx.scrollToIndex(dotIndex)),
          role: "button"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["mdi", item.icon])
          }, null, 2),
          (dotIndex === _ctx.index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
                _createElementVNode("svg", { viewBox: "0 0 36 36" }, [
                  _createElementVNode("path", {
                    class: "ring-bg",
                    d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  }),
                  _createElementVNode("path", {
                    class: "ring-progress",
                    style: {"stroke-dasharray":"100, 100"},
                    d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  })
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4)), [
          [_directive_tooltip, _ctx.projectLabels[dotIndex], _ctx.tooltipPosition]
        ])
      }), 128))
    ], 2)
  ]))
}